import { resolveColor, CHART_TONE } from "./chartStyles"

/*
 * MARK V — Sparkline. Mini-tendência SVG inline p/ KPI cards / células de
 * tabela. Sem eixos/labels. Auto-cor por direção (último vs primeiro) salvo
 * cor explícita. Porte fiel de
 * mark-v-design-system/components/charts/Sparkline.jsx.
 */

export type SparklineProps = {
  points: number[]
  width?: number
  height?: number
  color?: string
  area?: boolean
  endDot?: boolean
  strokeWidth?: number
  className?: string
}

export function Sparkline({
  points,
  width = 96,
  height = 28,
  color,
  area = true,
  endDot = true,
  strokeWidth = 2,
  className = "",
}: SparklineProps) {
  const n = points.length
  if (n === 0) return null

  const pad = strokeWidth + 1
  const lo = Math.min(...points)
  const hi = Math.max(...points)
  const span = hi - lo || 1
  const x = (i: number) => pad + (n > 1 ? (i / (n - 1)) * (width - pad * 2) : 0)
  const y = (v: number) => height - pad - ((v - lo) / span) * (height - pad * 2)

  const firstVal = points[0] as number
  const lastVal = points[n - 1] as number
  const auto = lastVal >= firstVal ? CHART_TONE.positive : CHART_TONE.negative
  const stroke = resolveColor(color, auto)

  const line = points
    .map((v, i) => `${i === 0 ? "M" : "L"}${x(i).toFixed(1)},${y(v).toFixed(1)}`)
    .join(" ")
  const fill = `${line} L${x(n - 1).toFixed(1)},${height} L${x(0).toFixed(1)},${height} Z`

  return (
    <svg
      className={`mv-spark ${className}`.trim()}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      style={{ display: "block", overflow: "visible" }}
    >
      {area && <path d={fill} fill={stroke} opacity="0.12" stroke="none" />}
      <path
        d={line}
        fill="none"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      {endDot && <circle cx={x(n - 1)} cy={y(lastVal)} r={strokeWidth + 0.5} fill={stroke} />}
    </svg>
  )
}
